import React from 'react';
import styled from 'styled-components';

// 导入SVG图标作为React组件
const CloseIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.49268 13.4927L13.478 4.50739"
      stroke="white"
      strokeWidth="1.77899"
      strokeLinecap="round"
    />
    <path
      d="M13.4779 13.4927L4.49262 4.50739"
      stroke="white"
      strokeWidth="1.77899"
      strokeLinecap="round"
    />
  </svg>
);

interface CloseButtonProps {
  onClick?: () => void;
  size?: 'small' | 'medium' | 'large';
}

const StyledButton = styled.button<{ size: 'small' | 'medium' | 'large' }>`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  border: none;
  background-color: #333333;
  cursor: pointer;
  transition: background-color 0.3s ease;

  /* 根据size属性设置不同的大小 */
  width: ${({ size }) => (size === 'small' ? '24px' : size === 'large' ? '40px' : '32px')};

  height: ${({ size }) => (size === 'small' ? '24px' : size === 'large' ? '40px' : '32px')};

  /* 调整图标大小 */
  svg {
    width: ${({ size }) => (size === 'small' ? '12px' : size === 'large' ? '20px' : '16px')};

    height: ${({ size }) => (size === 'small' ? '12px' : size === 'large' ? '20px' : '16px')};
  }

  &:hover {
    background-color: #444444;
  }

  &:active {
    background-color: #555555;
  }
`;

const CloseButton: React.FC<CloseButtonProps> = ({ onClick, size = 'medium' }) => {
  return (
    <StyledButton onClick={onClick} size={size}>
      <CloseIcon />
    </StyledButton>
  );
};

export default CloseButton;
